/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvoiceAgeGroup {
    ALL = 'ALL',
    RECEIVED_TODAY = 'Received Today',
    _1_7_DAYS = '1-7 days',
    _8_15_DAYS = '8-15 days',
    _16_DAYS = '16+ days',
}
